import { AxiosError } from 'axios';
import {
  APPLY_INCOMING_CONNECTIONS_REQUEST,
  APPLY_INCOMING_CONNECTIONS_SUCCESS,
  FETCH_ACTIVE_CONNECTIONS_FAILURE,
  FETCH_ACTIVE_CONNECTIONS_REQUEST,
  FETCH_ACTIVE_CONNECTIONS_SUCCESS,
  FETCH_ALL_PENDING_CONNECTIONS_FAILURE,
  FETCH_ALL_PENDING_CONNECTIONS_REQUEST,
  FETCH_ALL_PENDING_CONNECTIONS_SUCCESS,
  FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_FAILURE,
  FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_REQUEST,
  FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_SUCCESS,
  FETCH_PENDING_CONNECTIONS_COUNT_FAILURE,
  FETCH_PENDING_CONNECTIONS_COUNT_REQUEST,
  FETCH_PENDING_CONNECTIONS_COUNT_SUCCESS
} from '../constants/connections';
import { Actions } from '../actions/connections';
import { IPendingConnection } from '../interfaces';

export type State = {
  allPendingConnections: IPendingConnection[];
  activeConnectionsCount: number;
  // `null` means "not fetched yet" — consumers use it to hold their initial render steady (CPRO-15342)
  pendingConnectionsCount: number | null;
  // `null` means "not fetched yet"
  connectionsWithNoServicesCount: number | null;
  error: AxiosError | null;
  isFetching: boolean;
  // The count fetch keeps its own flag: `isFetching` is shared with the payment-consent fetches, and the
  // To Do widget's spinner must not react to unrelated connection activity.
  isFetchingPendingConnectionsCount: boolean;
  isFetchingConnectionsWithNoServicesCount: boolean;
};

const initialState: State = {
  allPendingConnections: [],
  activeConnectionsCount: 0,
  pendingConnectionsCount: null,
  connectionsWithNoServicesCount: null,
  error: null,
  isFetching: false,
  isFetchingPendingConnectionsCount: false,
  isFetchingConnectionsWithNoServicesCount: false
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_ALL_PENDING_CONNECTIONS_REQUEST:
    case FETCH_ACTIVE_CONNECTIONS_REQUEST:
    case APPLY_INCOMING_CONNECTIONS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_PENDING_CONNECTIONS_COUNT_REQUEST:
      return {
        ...state,
        isFetchingPendingConnectionsCount: true
      };
    case FETCH_ALL_PENDING_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        allPendingConnections: action.payload
      };
    case FETCH_PENDING_CONNECTIONS_COUNT_SUCCESS:
      return {
        ...state,
        isFetchingPendingConnectionsCount: false,
        pendingConnectionsCount: action.payload
      };
    case FETCH_ACTIVE_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        activeConnectionsCount: action.payload
      };
    case APPLY_INCOMING_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false
      };
    case FETCH_ALL_PENDING_CONNECTIONS_FAILURE:
    case FETCH_ACTIVE_CONNECTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case FETCH_PENDING_CONNECTIONS_COUNT_FAILURE:
      return {
        ...state,
        isFetchingPendingConnectionsCount: false,
        error: action.error
      };
    case FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_REQUEST:
      return {
        ...state,
        isFetchingConnectionsWithNoServicesCount: true
      };
    case FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_SUCCESS:
      return {
        ...state,
        isFetchingConnectionsWithNoServicesCount: false,
        connectionsWithNoServicesCount: action.payload
      };
    case FETCH_CONNECTIONS_WITH_NO_SERVICES_COUNT_FAILURE:
      return {
        ...state,
        isFetchingConnectionsWithNoServicesCount: false,
        error: action.error
      };
    default:
      return state;
  }
}
